<template>
  <el-tooltip
    v-if="isShow"
    class="item"
    effect="dark"
    placement="top-end"
    :open-delay="openDelay"
    :content="tip"
    >
    <el-button
      type="primary"
      size="small"
      icon="el-icon-link"
      @click="open"
      >
      {{ $t('route.website') }}
    </el-button>
  </el-tooltip>
</template>

<script>

export default {
  name: 'web-link',
  props: {
    isShow: {
      type: Boolean,
      default: true
    },
    tip: {
      type: String
    },
    path: {
      type: String
    },
    id: {
      type: Number
    },
    openDelay: {
      type: Number,
      default: 500
    }
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
    open () {
      let param = (this.id !== undefined) ? this.id : ''
      window.open(process.env.WEB_URL + this.path + param, '_blank')
    }
  }
}
</script>
